import { Flex } from 'antd';
import styles from './sign-in.module.scss';
import { Oauth } from './oauth';
import { Logo } from '@shared/assets/icons/components';
import { Text } from '@shared/ui/antd';
import { useTranslation } from 'react-i18next';

export const SignInPage = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'auth.signIn' });
  return (
    <Flex justify="start" align="center" className={styles.simpleRoot}>
      <Flex align="center" gap={6} className={styles.logoRow}>
        <Logo className={styles.logo} />

        <Text variant="2xl" fontWeight={600}>
          echogpt.ai
        </Text>
      </Flex>

      <Flex gap={24} justify="center" align="center" className={styles.simpleContainer} vertical>
        <Text variant="2xl" fontWeight={500} className={styles.simpleTitle}>
          {t('pageTitle')}
        </Text>

        <Oauth />
      </Flex>
    </Flex>
  );
};
